import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
    ActivatedRouteSnapshot,
    NavigationEnd,
    Router,
    RouterModule
} from '@angular/router';

import { BehaviorSubject } from 'rxjs';
import { ButtonModule } from 'primeng/button';
import { filter } from 'rxjs/operators';
import { StateDeclaration, UIRouter } from '@uirouter/core';

interface Breadcrumb {
    label: string;
    url?: string;
}

@Component({
    selector: '[app-breadcrumb]',
    standalone: true,
    imports: [CommonModule, RouterModule, ButtonModule],
    template: ` <div class="layout-breadcrumb-container">
        <div class="layout-breadcrumb-buttons">
            <button
                pButton
                pRipple
                type="button"
                icon="pi pi-power-off"
                class="p-button-rounded p-button-text p-button-plain"
            ></button>
        </div>
    </div>`,
    host: {
        class: 'content-breadcrumb'
    }
})
export class AppBreadcrumb {
    constructor(){}
    // private readonly _breadcrumbs$ = new BehaviorSubject<Breadcrumb[]>([]);

    // readonly breadcrumbs$ = this._breadcrumbs$.asObservable();

    // constructor(private router: UIRouter) {
    //     this.router.transitionService.onSuccess({}, transition => {
    //         const root = this.router.stateService.get('root');
    //         const breadcrumbs: Breadcrumb[] = [];
    //         this.addBreadcrumb(root, [], breadcrumbs);

    //         this._breadcrumbs$.next(breadcrumbs);
    //     });
    // }

    // private addBreadcrumb(
    //     state: StateDeclaration,
    //     parentUrl: string[],
    //     breadcrumbs: Breadcrumb[]
    // ) {
    //     const stateUrl = parentUrl.concat(state.url || []);
    //     const breadcrumb = state.data?.breadcrumb;
    //     const parentBreadcrumb =
    //         typeof state.parent === 'object'
    //             ? state.parent.data?.breadcrumb
    //             : undefined;

    //     if (breadcrumb && breadcrumb !== parentBreadcrumb) {
    //         breadcrumbs.push({
    //             label: breadcrumb,
    //             url: '/' + stateUrl.join('/')
    //         });
    //     }

    //     const childStates = (state as any).children;
    //     if (childStates) {
    //         childStates.forEach((childState: StateDeclaration) => {
    //             this.addBreadcrumb(childState, stateUrl, breadcrumbs);
    //         });
    //     }
    // }
}
